package pl.decks.personal.components.widgets.pageprogress

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.widgets.pageprogress.PageProgressPointsBarStylesheet.Line
import pl.decks.personal.components.widgets.pageprogress.PageProgressPointsBarStylesheet.Point

enum class ProgressPoint {
    VISITED,
    ACTIVE,
    NEXT,
    FUTURE;

    fun toPointStyleVariant(): CssStyleVariant<Point.Kind> = when (this) {
        VISITED -> Point.VisitedVariant
        ACTIVE -> Point.ActiveVariant
        NEXT -> Point.NextVariant
        FUTURE -> Point.FutureVariant
    }

    fun toProgressLineStyleVariant(): CssStyleVariant<Line.Kind> = when (this) {
        VISITED -> Line.VisitedVariant
        ACTIVE -> Line.ActiveVariant
        else -> Line.FutureVariant
    }
}


@Composable
internal fun PageProgressPointsBar(
    numberBreakpoints: Int,
    activeBreakpoint: Int,
    modifier: Modifier = Modifier,
    onPointClicked: (Int) -> Unit,
) {
    Column(
        modifier = PageProgressPointsBarStylesheet.Bar.Container.toModifier().then(modifier),
        verticalArrangement = Arrangement.SpaceEvenly,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        val pointRange = 0 until numberBreakpoints
        pointRange.forEach { point ->
            val progressState = when {
                point < activeBreakpoint -> ProgressPoint.VISITED
                point == activeBreakpoint -> ProgressPoint.ACTIVE
                point - 1 == activeBreakpoint -> ProgressPoint.NEXT
                else -> ProgressPoint.FUTURE
            }
            Box(
                Point.Style
                    .toModifier(progressState.toPointStyleVariant())
                    .cursor(Cursor.Pointer)
                    .onClick { onPointClicked(point) },
                contentAlignment = Alignment.Center,
            ) {
                Box(Point.Content.toModifier())
            }
            if (point != pointRange.last) {
                Box(Line.Style.toModifier(progressState.toProgressLineStyleVariant()).weight(1f))
            }
        }
    }
}
